export enum ActionMode {
  TOGGLE,
  VIEW,
  MOVE,
  CLONE,
  DELETE,
}
